import React, { ComponentProps } from 'react'
import Group from 'components/utils/Group'

type Props = Omit<ComponentProps<typeof Group>, 'direction' | 'gap' | 'noDisplayWhenEmpty' | 'verticalAlign'>

function LabelGroup(props: Props) {
  const { className, wrap, ...rest } = props
  // Why the double <Group>?
  // Because we don't want to let the label group to stretch.
  return <Group
    className={className}
    direction="horizontal"
    verticalAlign="start"
    horizontalAlign="stretch"
  >
    <Group
      {...rest}
      direction="horizontal"
      verticalAlign="center"
      gap={4}
      wrap={wrap ?? 'wrap'}
      noDisplayWhenEmpty
    />
  </Group>
}

export default LabelGroup
